class Monitoring.Methods.UniqueId

  constructor: () ->
    @store = {}

  generate: () ->
    base = 36
    time = Date.now().toString(base)
    random = Math.random().toString(base).substr(2, 16)
    "#{time}#{random}"

  get: (key) ->
    return @store[key] if @store[key]
    id = @generate()
    @store[key] = id
    id

window.UniqueId = new Monitoring.Methods.UniqueId()
